import { BTMenu } from "@btnet/core-components/BTMenu";

import { BTIconBlockquotes } from "commonComponents/btWrappers/BTIcon";
import { isSelectionExclusivelyInTitle } from "commonComponents/btWrappers/editor/core/editor.utils";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "blockquote";
const friendlyName = "Blockquote";
const icon = <BTIconBlockquotes />;
const onClick = (editor: IEditor) => {
    return editor.tiptapEditor.chain().focus().toggleBlockquote().run();
};

export const blockquoteControl: ICollapsableControl = {
    key: extensionId,
    isControlSupported(supportedExtensions: Set<ExtensionName>, editor: IEditor) {
        return (
            supportedExtensions.has(extensionId) && editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                friendlyName={friendlyName}
                data-testid="blockquoteControl"
                icon={icon}
                isToggled={editor.tiptapEditor.isActive(extensionId)}
                onClick={() => onClick(editor)}
                disabled={!this.isControlEnabled(editor)}
            />
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return (
            tiptapEditor.can().chain().focus().toggleBlockquote().run() &&
            !isSelectionExclusivelyInTitle(tiptapEditor, tiptapEditor.state.selection)
        );
    },
    collapsedActiveKeys({ tiptapEditor }) {
        return tiptapEditor.isActive(extensionId) ? [extensionId] : [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                key={this.key}
                menuProps={{
                    testid: this.key,
                    onClick: () => onClick(editor),
                    className: "btEditorControlBarMenuItem",
                    icon,
                    disabled: !this.isControlEnabled(editor),
                }}
            >
                {friendlyName}
            </InputRecaptureHackMenuItem>
        );
    },
};
export default blockquoteControl;
